// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-contract-dialog.common-dialog[data-v-6f52743d] .el-dialog{width:var(--common-dialog-medium-width)}.edit-contract-dialog.common-dialog .el-form[data-v-6f52743d]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
